<template>
  <div class="flex flex-row items-center text-red-600 mt-6">
    <Icon name="hourglass_top" class="w-5 h-5 text-primary text-2xl"/>
    <span class="text-2xl text-zinc-800 font-semibold ml-2">{{ formattedTime }}</span>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import {Icon} from "@/components/block/icon";

const props = defineProps({
  expiresAt: String,
  initialSeconds: Number
});

const emit = defineEmits(['time-up']);

const remainingSeconds = ref(props.initialSeconds || 0);
let interval = null;

const formattedTime = computed(() => {
  const hh = Math.floor(remainingSeconds.value / 3600);
  const mm = Math.floor((remainingSeconds.value % 3600) / 60);
  const ss = remainingSeconds.value % 60;
  if (hh > 0) {
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
  }
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
});

function startTimer() {
  interval = setInterval(() => {
    if (remainingSeconds.value > 0) {
      remainingSeconds.value--;
    } else {
      clearInterval(interval);
      emit('time-up');
    }
  }, 1000);
}

onMounted(() => {
  if (props.expiresAt && !props.initialSeconds) {
    const expires = new Date(props.expiresAt);
    remainingSeconds.value = Math.max(0, Math.floor((expires - new Date()) / 1000));
  }
  if (props.expiresAt) startTimer();
});

onUnmounted(() => {
  if (interval) clearInterval(interval);
});
</script>
